<template>
  <section class="form-group">
    <header v-if="title" class="header">
      {{ title }}
      <div v-if="required" class="required">{{ $t('required') }}</div>
    </header>
    <aside v-if="$slots.aside" class="aside">
      <!-- @slot タイトル脇に配置されます -->
      <slot name="aside" />
    </aside>
    <div class="contents">
      <!-- @slot フォームコンテンツ -->
      <slot />
    </div>
  </section>
</template>

<script>
/**
 * フォームグループ
 */
export default {
  name: 'FormGroup',
  props: {
    /** 見出し */
    title: { type: String, default: null },
    /** 必須かどうか */
    required: { type: Boolean, default: false },
  },
}
</script>

<style lang="postcss" scoped>
/* autoprefixer grid: autoplace */
.form-group {
  overflow: hidden;
  width: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    display: grid;
    flex-direction: column;
    grid-gap: 8px 16px;
    grid-template: 'header aside' 'contents contents' / max-content 1fr;
    margin: auto;
    max-width: 740px;

    & + .form-group {
      margin-top: 32px;
    }
  }
}

.header {
  align-items: center;
  background: var(--very-light-gray-2);
  display: flex;
  font-size: 14px;
  font-weight: 600;
  grid-area: header;
  justify-content: flex-start;
  padding: 8px 16px;

  @media screen and (min-width: 768px) {
    background: none;
    padding: 0;
  }
}

.required {
  align-items: center;
  background: #e53935;
  color: #fff;
  display: flex;
  font-size: 12px;
  height: 16px;
  margin-left: 8px;
  padding: 0 4px;

  @media screen and (min-width: 768px) {
    padding: 0 8px;
  }
}

.aside {
  display: flex;
  grid-area: aside;
  justify-self: flex-start;
  padding: 16px 16px 0;

  @media screen and (min-width: 768px) {
    padding: 0;
  }
}

.contents {
  display: flex;
  flex-direction: column;
  grid-area: contents;
  padding: 16px;

  @media screen and (min-width: 768px) {
    padding: 0;
  }
}
</style>
